import {
  addDays,
  formatPrototypeDate,
  formatPrototypeDateShort,
  getPrototypeToday,
} from "../prototypeDates";

export type ReportedProduct = {
  id: string;
  issueLabel: string;
  name: string;
  variant: string;
  imageUrl: string;
};

export const BRAND_NAME = "Ro & Co";

const returnByDate = addDays(getPrototypeToday(), 11);

export const RETURN_BY_DATE = formatPrototypeDateShort(returnByDate);
export const RETURN_BY_DATE_LONG = formatPrototypeDate(returnByDate);

export const LINEN_BUTTON_DOWN_TANK_IMAGE =
  "/images/ck/brand-portal-issues-page/linen-button-down-tank.png";

export const CHAMBRAY_HEARTS_SHIRT_IMAGE =
  "/images/ck/brand-portal-issues-page/chambray-hearts-shirt.png";

export const REPORTED_PRODUCTS: ReportedProduct[] = [
  {
    id: "glass-tumbler-damaged",
    issueLabel: "Quality (2 of 6)",
    name: "Linen Button-down Tank",
    variant: "Black",
    imageUrl: LINEN_BUTTON_DOWN_TANK_IMAGE,
  },
  {
    id: "glass-tumbler-missing",
    issueLabel: "Missing (2 of 6)",
    name: "Glass Tumbler",
    variant: "12 in / Brown",
    imageUrl:
      "https://www.figma.com/api/mcp/asset/286f8066-c591-4c9f-805b-95777f424fa4.png",
  },
  {
    id: "side-dish-quality",
    issueLabel: "Quality (2 of 6)",
    name: "Chambray Hearts Shirt",
    variant: "Blue",
    imageUrl: CHAMBRAY_HEARTS_SHIRT_IMAGE,
  },
];

export const RETURN_ITEMS: ReportedProduct[] = [
  {
    id: "glass-tumbler-damaged",
    issueLabel: "Quality (2)",
    name: "Linen Button-down Tank",
    variant: "Black",
    imageUrl: LINEN_BUTTON_DOWN_TANK_IMAGE,
  },
  {
    id: "side-dish-quality",
    issueLabel: "Quality (2)",
    name: "Chambray Hearts Shirt",
    variant: "Blue",
    imageUrl: CHAMBRAY_HEARTS_SHIRT_IMAGE,
  },
];
